/* eslint-disable camelcase */
import { WWW_ORIGIN } from '../../config';

interface ResetPasswordPayload {
  userId: string;
  email: string;
}
interface PatchFederatedUserPayload {
  email: string;
  firstName: string;
  lastName: string;
  xometryUserId: string;
  completingRegistration: boolean;
}
export default {
  patchFederatedUser(payload: PatchFederatedUserPayload) {
    return fetch(
      `${WWW_ORIGIN}/federated-identities-api/v1/federated-identity/user`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: {
          Cookie: document.cookie,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );
  },
  postStaffResetPassword(payload: ResetPasswordPayload) {
    return fetch(
      `${WWW_ORIGIN}/federated-identities-api/v1/federated-identity/${payload.userId}/reset-password`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Cookie: document.cookie,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );
  },
  postResetPassword(payload: ResetPasswordPayload) {
    return fetch(
      `${WWW_ORIGIN}/federated-identities-api/v1/federated-identity/reset-password`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Cookie: document.cookie,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );
  },
  postResendVerificationEmail(userId: string) {
    return fetch(
      `${WWW_ORIGIN}/federated-identities-api/v1/federated-identity/resend-email-verification/${userId}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Cookie: document.cookie,
          'Content-Type': 'application/json',
        },
      }
    );
  },
};
